// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-fallthrough, default-param-last, consistent-return, require-await */
/* eslint prefer-promise-reject-errors: "warn" */
import { Map, Record } from "immutable"
import type { Dispatch } from "redux"
import { getLanguageInfo } from "@kiwicom/frontend-common/services/staticData"
import { ERROR, LOADING, SUCCESS } from "@kiwicom/frontend-common/consts/phase"
import { getCurrency } from "@kiwicom/frontend-common/services/options/reducer"
import { MODALS } from "@kiwicom/frontend-common/consts/modals"
import { bidSelector } from "@kiwicom/frontend-common/services/booking/booking"
import { LOGOUT } from "@kiwicom/frontend-common/consts/nitroActions"

import { SPORTS_EQUIPMENT_SUBMIT_FAILURE } from "../scenes/BookingAdditionalServices/scenes/SportsEquipment/consts/actions"
import { SPECIAL_ASSISTANCE_SUBMIT_FAILURE } from "../scenes/BookingAdditionalServices/scenes/SpecialAssistance/consts/actions"
import { PETS_SUBMIT_FAILURE } from "../scenes/BookingAdditionalServices/scenes/Pets/consts/actions"
import { MUSICAL_EQUIPMENT_SUBMIT_FAILURE } from "../scenes/BookingAdditionalServices/scenes/MusicalEquipment/consts/actions"
import type { BookingId } from "../../../../../types/primitiveTypes"
import * as bookingsApi from "../../../../../services/bookings/bookingsApi"
import * as manageApi from "./api/manageApi"
import { ACTIONS, BOOKING_STATUSES } from "../../../../../consts/booking"
import type {
  Action,
  BookingActionAction,
  BookingInvalidateEndAction,
  BookingInvalidateStartAction,
  BookingResetAction,
  BookingStateInst,
  GetState,
} from "./types"
import { SUBMIT_ORDER_CORRECTION_FAILURE } from "../scenes/BookingPassengerEdit/services/consts"
import {
  ACTION,
  ACTION_FAILURE,
  ACTION_SUCCESS,
  CHANGE_VIEW,
  CLEAR_ERROR,
  CLEAR_SUCCESS,
  INVALIDATE_END,
  INVALIDATE_START,
  LOAD,
  LOAD_FAILURE,
  LOAD_REQUEST,
  LOAD_SUCCESS,
  RELOAD,
  RELOAD_FAILURE,
  RELOAD_SUCCESS,
  RESET,
  SET_MODAL_OPEN,
  SET_REFUND_SHOT_MODAL_OPEN,
} from "./consts"
import { SUBMIT_FAILURE as INSURANCE_SUBMIT_FAILURE } from "./bookingInsurance/consts"
import { CONFIRM_FAILURE as FLIGHT_CHANGE_SUBMIT_FAILURE } from "./changeFlights/consts"
import { additionalContactsReducer } from "../scenes/AdditionalContacts/services/additionalContactsApi"
import { fetchServicePackageRulesetAction } from "../scenes/ServicePackage/services/servicePackageActions"
import { closeModalAction } from "./bookingActions"
import {
  loadAncillaries as loadAncillariesAction,
  loadAncillariesApiOffers,
} from "../scenes/BookingAncillary/services/BookingAncillaryDuck"
import { fetchEmergencyBannersAction } from "./emergencyBanners/actions"
import {
  SHOPPING_BASKET_UPDATING_END,
  SHOPPING_BASKET_UPDATING_START,
} from "../scenes/BookingPayment/services/constants/conts"
import { REDIRECT_TO_SHOPPING_BASKET_FAILURE } from "../../../../../services/mmb2/types"
import { getFareTypeAction } from "./fareType"
import { queryClient } from "./reactQuery/reactQuery"

// README:
// actions have 'payload' on them because of this.
// see 'bookingSelectors' for usage
// @ts-expect-error: Flow to TS migration.
const Message = new Record({
  action: null,
  payload: null,
  error: null,
})

// @ts-expect-error: Flow to TS migration.
const BookingState = new Record({
  data: null,
  phase: LOADING,
  invalidating: false,
  error: null,
  success: null,
  modal: null,
  previousModal: null,
})

export default function bookingReducer(
  state: Map<string, BookingStateInst> | null | undefined = new BookingState(),
  raw: Action,
) {
  if (!(state instanceof BookingState)) return new BookingState()

  const action = raw
  // @ts-expect-error: Flow to TS migration.
  if (action.bid) {
    // Maps recognize between numbers and strings
    // @ts-expect-error: Flow to TS migration.
    action.bid = Number(action.bid)
  }

  switch (action.type) {
    case CHANGE_VIEW:
      // @ts-expect-error: Flow to TS migration.
      return state.set("view", action.view)

    case SET_MODAL_OPEN:
      // @ts-expect-error: Flow to TS migration.
      return state.set("modal", action.modal).set("previousModal", state.get("modal"))

    case SET_REFUND_SHOT_MODAL_OPEN:
      // @ts-expect-error: Flow to TS migration.
      return state.set("modal", MODALS.REFUND).set("previousModal", MODALS.SCHEDULE_CHANGE)

    case CLEAR_ERROR:
      // @ts-expect-error: Flow to TS migration.
      return state.set("error", null)

    case CLEAR_SUCCESS:
      // @ts-expect-error: Flow to TS migration.
      return state.set("success", null)

    // load
    // ---
    case LOAD_REQUEST:
      // @ts-expect-error: Flow to TS migration.
      return state.set("phase", LOADING)

    case LOAD_SUCCESS:
      // @ts-expect-error: Flow to TS migration.
      return state.set("phase", SUCCESS).set("data", action.res)

    case LOAD_FAILURE:
      // @ts-expect-error: Flow to TS migration.
      return state.set("phase", ERROR).set(
        "error",
        new Message({
          error: action.error,
          payload: action.type,
        }),
      )

    // reload
    // ---

    case RELOAD_SUCCESS:
      // @ts-expect-error: Flow to TS migration.
      return state.set("data", action.res)

    case RELOAD_FAILURE:
      // @ts-expect-error: Flow to TS migration.
      return state.set(
        "error",
        new Message({
          action: ACTIONS.INVALIDATE,
          error: action.error,
        }),
      )

    // reset || unload
    // ---

    // @ts-expect-error: Flow to TS migration.
    case LOGOUT:
      return new BookingState()

    case RESET:
      // @ts-expect-error: Flow to TS migration.
      return state.clear()

    // action
    // ---
    case ACTION_SUCCESS: {
      if (action.action === ACTIONS.ADDITIONAL_CONTACTS) {
        return additionalContactsReducer(state, action)
      }
      // @ts-expect-error: Flow to TS migration.
      return state.set("success", new Message(action))
    }
    case ACTION_FAILURE:
    // @ts-expect-error: Flow to TS migration.
    case SPORTS_EQUIPMENT_SUBMIT_FAILURE:
    // @ts-expect-error: Flow to TS migration.
    case SPECIAL_ASSISTANCE_SUBMIT_FAILURE:
    // @ts-expect-error: Flow to TS migration.
    case PETS_SUBMIT_FAILURE:
    // @ts-expect-error: Flow to TS migration.
    case MUSICAL_EQUIPMENT_SUBMIT_FAILURE:
    // @ts-expect-error: Flow to TS migration.
    case FLIGHT_CHANGE_SUBMIT_FAILURE:
    // @ts-expect-error: Flow to TS migration.
    case INSURANCE_SUBMIT_FAILURE:
    // @ts-expect-error: Flow to TS migration.
    case SUBMIT_ORDER_CORRECTION_FAILURE:
    // @ts-expect-error: Flow to TS migration.
    case REDIRECT_TO_SHOPPING_BASKET_FAILURE:
      // @ts-expect-error: Flow to TS migration.
      return state.set("error", new Message(action)).set("invalidating", false)

    // invalidate booking and adding items to shopping basket re-use the same loader
    // ---

    // @ts-expect-error: Flow to TS migration.
    case SHOPPING_BASKET_UPDATING_START:
    case INVALIDATE_START:
      // @ts-expect-error: Flow to TS migration.
      return state.set("invalidating", true)

    // @ts-expect-error: Flow to TS migration.
    case SHOPPING_BASKET_UPDATING_END:
    case INVALIDATE_END:
      // @ts-expect-error: Flow to TS migration.
      return state.set("invalidating", false)

    default:
      return state
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const loadAncillariesOffers = (dispatch: Dispatch<any>, bid: BookingId) => {
  dispatch(loadAncillariesApiOffers(bid))
}

const loadBookingFactory = (type: string) => (bid: BookingId) => async (
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>,
  getState: GetState,
) => {
  const state = getState()
  const languageInfo = getLanguageInfo(state)
  const currency = getCurrency(state)
  const promise = bookingsApi.findOne(bid, languageInfo.api)

  try {
    // Catch with Promise.resolve is used so the Promise.all resolves even when there is error
    // Actual errors are handled in the actions themselves
    // the alternative Promise.allSettled is not supported by flow.
    await Promise.all([
      // @ts-expect-error: Flow to TS migration.
      dispatch(loadAncillariesAction()).catch(() => Promise.resolve()),
      dispatch(fetchServicePackageRulesetAction(bid, currency)),
      dispatch(getFareTypeAction(bid)),
    ])
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/await-thenable
    const ok = await dispatch({
      type,
      promise,
      bid,
      _track: { bid },
    })

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (ok) {
      const booking = await promise
      // @ts-expect-error: Flow to TS migration.
      const isConfirmed = booking.status === BOOKING_STATUSES.CONFIRMED

      await Promise.all([
        isConfirmed && loadAncillariesOffers(dispatch, bid),
        dispatch(fetchEmergencyBannersAction(bid, languageInfo.phraseApp)),
      ])
    }
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return err
  }
}

const invalidateBooking = loadBookingFactory(RELOAD)
export const loadBooking = loadBookingFactory(LOAD)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const reloadBooking = (bid: BookingId, showLoader: boolean = true) => {
  return async (dispatch: Dispatch) => {
    if (showLoader) {
      dispatch({ type: INVALIDATE_START } as BookingInvalidateStartAction)
    }
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/await-thenable
    await dispatch(invalidateBooking(bid))
    // invalidate BFF booking_details to re-fetch it for the latest state
    await queryClient.invalidateQueries()
    if (showLoader) {
      dispatch({ type: INVALIDATE_END } as BookingInvalidateEndAction)
    }
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const reloadBookingAndCloseModal = () => (dispatch: Dispatch<any>, getState: GetState) => {
  const bid = bidSelector(getState())
  dispatch(reloadBooking(bid))
  dispatch(closeModalAction())
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const resetBooking = () => async (dispatch: Dispatch<any>) => {
  dispatch({ type: RESET } as BookingResetAction)
}

// Booking services
// ---
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const requestFastRefund = (bid: BookingId) => async (dispatch: Dispatch<any>) => {
  dispatch({ type: INVALIDATE_START } as BookingInvalidateStartAction)
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/await-thenable
  const ok = await dispatch({
    type: ACTION,
    action: ACTIONS.REQUEST_FAST_REFUND,
    promise: manageApi.requestFastRefund(bid),
    bid,
    payload: { bid },
    _track: { action: ACTIONS.REQUEST_FAST_REFUND, bid },
  } as BookingActionAction)

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/await-thenable
  await dispatch(invalidateBooking(bid))
  dispatch({ type: INVALIDATE_END } as BookingInvalidateEndAction)
  dispatch(closeModalAction())
  return ok
}
